// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@5.2.7@css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".business[data-v-7b79f02e]{padding-top:60px}.business[data-v-7b79f02e] .head{text-align:center}.business[data-v-7b79f02e] .head .title{color:#333;font-size:32px;font-weight:400}.businesslist[data-v-7b79f02e]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:90%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
